import { useMemo } from 'react';
import type { ProductGroupById } from '../contexts/ProductGroupsProvider';
import type { ResourceLibraryItemBase } from '../types/resourceLibraryItems';
import { resolveHeaderBackgroundPath } from '../tools/itemHeaderBackground';

interface UseItemHeaderBackgroundArgs {
    item: ResourceLibraryItemBase | null;
    /** Map of product group ID to product group data. */
    productGroupById: ProductGroupById;
    /** Optional Pimcore fallback PATH (not URL). */
    fallbackPath?: string;
}

/**
 * Returns the absolute URL for the item's header background image,
 * preferring product groups (and their parents) then falling back to the provided path.
 */
export function useItemHeaderBackground({
    item,
    productGroupById,
    fallbackPath,
}: UseItemHeaderBackgroundArgs): string | undefined {
    return useMemo(
        () => resolveHeaderBackgroundPath(item, productGroupById, fallbackPath) ?? undefined,
        [item, productGroupById, fallbackPath]
    );
}
